(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-einstant/assets/javascripts/shared/hooks/use-local-storage.js') >= 0) return;  svs.modules.push('/modules/tickets-einstant/assets/javascripts/shared/hooks/use-local-storage.js');
"use strict";

const {
  useState,
  useCallback,
  useEffect,
  useRef
} = React;
const useLocalStorage = function (key, domain) {
  let initialValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  let expirationTimeMinutes = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  const [storedValue, setStoredValue] = useState(initialValue);
  const mounted = useRef(false);
  const loadStoredValue = async () => {
    svs.components.Storage.browser.get(key, domain, value => {
      if (mounted.current) {
        setStoredValue(value || initialValue);
      }
    });
  };
  useEffect(() => {
    mounted.current = true;
    loadStoredValue();
    return () => {
      mounted.current = false;
    };
  }, []);
  useEffect(() => {
    loadStoredValue();
  }, [key, domain]);
  const setValue = useCallback(function (value) {
    let cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    setStoredValue(storedValue => {
      const valueToStore = typeof value === 'function' ? value(storedValue) : value;
      svs.components.Storage.browser.set(key, domain, valueToStore, expirationTimeMinutes, cb);
      return valueToStore;
    });
  }, [key, domain, expirationTimeMinutes]);
  const clearValue = useCallback(() => {
    svs.components.Storage.browser.remove(key, domain);
    setStoredValue(initialValue);
  }, [key, domain, initialValue]);
  const clearStorage = () => {
    svs.components.Storage.browser.remove(key, domain);
  };
  return [storedValue, setValue, clearValue, clearStorage];
};
setGlobal('svs.eInstant.shared.hooks.useLocalStorage', useLocalStorage);

 })(window);